<div class="info-popup" *ngIf="!_as.isOnMobilePlatform">
    <p-dialog [(visible)]="_abpopupinfo.visibleInfoPopup" [transitionOptions]="'350ms cubic-bezier(0, 0, 0.2, 1)'"
      [modal]="true" [position]="_abpopupinfo.infoPosition" [closable]="false" (onHide)="_abpopupinfo.reSetData()">
      <!-- <div class="close-popup" (click)="closecorepopup()" style="    right: 16px !important;
        top: 16px !important;">
            <img ngOptimizedImage 
                src="https://res.cloudinary.com/afterbricks/image/upload/v1672648092/unnamed_pnyzfp.png" alt="abpopupinfo"
                loading="lazy">
        </div> -->
      <ng-template pTemplate="header">
        <div class="info-back-btn" *ngIf="_abpopupinfo.step_type!=='user_type'">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 12 16" fill="none" aria-hidden="true">
            <path d="M6.65723 6.24707C6.76704 5.91764 7.233 5.91765 7.34281 6.24707L7.98828 8.1835C8.276 9.04666 8.95332 9.72399 9.81648 10.0117L11.7529 10.6572C12.0824 10.767 12.0824 11.233 11.7529 11.3428L9.81649 11.9883C8.95332 12.276 8.27599 12.9533 7.98828 13.8165L7.34281 15.7529C7.233 16.0823 6.76704 16.0823 6.65723 15.7529L6.01173 13.8165C5.72401 12.9533 5.04669 12.276 4.18353 11.9883L2.24707 11.3428C1.91764 11.233 1.91764 10.767 2.24707 10.6572L4.18353 10.0117C5.04669 9.72399 5.72401 9.04667 6.01173 8.18352L6.65723 6.24707Z" fill="#9763f6"></path>
            <path d="M2.79434 1.14824C2.86023 0.950586 3.1398 0.950587 3.20569 1.14824L3.59297 2.3101C3.7656 2.828 4.172 3.2344 4.6899 3.40703L5.85177 3.79432C6.04942 3.86021 6.04942 4.13978 5.85177 4.20567L4.6899 4.59296C4.172 4.76559 3.7656 5.17199 3.59297 5.68989L3.20569 6.85176C3.13981 7.04941 2.86023 7.04942 2.79434 6.85176L2.40704 5.68988C2.23441 5.17198 1.82801 4.76559 1.31012 4.59296L0.148241 4.20567C-0.0494137 4.13978 -0.0494138 3.86021 0.148241 3.79432L1.31012 3.40703C1.82802 3.2344 2.23441 2.82801 2.40704 2.31011L2.79434 1.14824Z" fill="#9763f6"></path>
            <path d="M9.8629 0.0988265C9.90682 -0.032943 10.0932 -0.0329419 10.1371 0.098828L10.3953 0.873401C10.5104 1.21867 10.7813 1.4896 11.1266 1.60469L11.9012 1.86288C12.0329 1.9068 12.0329 2.09319 11.9012 2.13711L11.1266 2.39531C10.7813 2.51039 10.5104 2.78133 10.3953 3.12659L10.1371 3.90117C10.0932 4.03294 9.90682 4.03294 9.8629 3.90117L9.6047 3.12659C9.48961 2.78132 9.21868 2.5104 8.87342 2.39531L8.09883 2.13711C7.96706 2.09319 7.96706 1.9068 8.09883 1.86288L8.87342 1.60469C9.21868 1.4896 9.48961 1.21867 9.6047 0.873408L9.8629 0.0988265Z" fill="#9763f6"></path>
          </svg>
          <!-- <p-button icon="pi pi-angle-left" (onClick)="_abpopupinfo.onBack()" styleClass="p-button-rounded p-button-secondary p-button-text"></p-button> -->
        </div>
        <span class="text-xl font-bold"> {{_abpopupinfo.heading}} </span>
        <br>
      </ng-template>
      <p *ngIf="_abpopupinfo.step_type!=='user_type'" style="position: absolute;right: 62px;top: 75px;color: #f56518; font-size: 12px;font-family:'SF UI Text Regular';">Beta version</p> 

      <ng-template pTemplate="content">
        <div *ngIf="_abpopupinfo.step_type==='user_type'">
          <ul class="info-ul-1">
            <li *ngFor="let ut of _abpopupinfo.usertypedata">
              <a class="info-card" [ngStyle]="{'background-color':ut.bgColor}" (click)="_abpopupinfo.onSelectUserType(ut.key)">
                
                <div class="info-img">
                  <img [src]="ut.icon" [alt]="ut.title">
                </div>
                <div class="info-content">
                  <h3>{{ut.title}}</h3>

                  <!-- <h3 [ngStyle]="{'color':ut.color}">{{ut.title}}</h3> -->
                  <!-- <p>{{ut.subtitle}}</p> -->
                  <!-- <p [ngStyle]="{'color':ut.color}">{{ut.subtitle}}</p> -->
                </div>
              </a>
            </li>
          </ul>
         
          <div class="footer-msg" >
            <span>{{_abpopupinfo.footermsg}}</span><br>
            <span  style="font-size: 12.5px; font-family:'SF UI Text Light';">{{_abpopupinfo.footermsgtwo}}</span>
          </div>
        </div>
        <div class="position-relative" *ngIf="_abpopupinfo.step_type==='product-selection-for'">
          <ul class="info-ul-1">
            <li *ngFor="let ut of _abpopupinfo.productSelectionfor">
              <a class="info-card " [ngStyle]="{'background-color':ut.bgColor}" (click)="_abpopupinfo.onProductSelectionFor(ut.key)">
                <div class="info-img">
                  <img [src]="ut.icon" [alt]="ut.title">
                </div>
                <div class="info-content">
                  <h3>{{ut.title}}</h3>
                  <p>{{ut.subtitle}}</p>
                </div>
              </a>
            </li>
          </ul>
          <div class="text-center mt-3" *ngIf="!_abpopupinfo.isAskBudgetSec">
            <span>Please click as per your project requirements</span>
          </div>
          <div class="full-renovartion-strip" *ngIf="_abpopupinfo.isAskBudgetSec">
            <div class="footer-msg" >
              <h3>Would you like to explore our budget optimization tool?</h3>
              <p>It allocates the entire budget to individual product categories</p>
              <div class="fns-btn-box">
                <button (click)="_abpopupinfo.onGoBudgetSec()">Yes</button>
                <button (click)="_abpopupinfo.closeInfoPopUp()">Latter</button>
              </div>
            </div>
          </div>
          
        </div>
        <div *ngIf="_abpopupinfo.step_type==='pro-message'">
          <ul class="info-ul-2 p-0">
            <li *ngFor="let ut of _abpopupinfo.profeaturelist">
              <a class="info-card info-card-pro">
                <div class="info-img-serch">
                  <img [src]="ut.icon" [alt]="ut.title">
                </div>
                <div class="info-content">
                  <h3>{{ut.title}}</h3>
                  <p>{{ut.subtitle}}</p>
                </div>
              </a>
            </li>
          </ul>
          <div class="continue-strip">
            <button class="later-btn" (click)="_abpopupinfo.onContinue()">Later</button>
            <button class="btn continue-btn" (click)="goSmartsearch()">Try now</button>
          </div>
        </div>
   </ng-template>
  </p-dialog>
  <p-dialog [(visible)]="_abpopupinfo.is_displaySaveIdeaInfoPopup" [transitionOptions]="'350ms cubic-bezier(0, 0, 0.2, 1)'"
  [modal]="true" [position]="_abpopupinfo.infoPosition" [closable]="false" [draggable]="false">
  <ng-template pTemplate="header">
    <div class="info-back-btn" *ngIf="_abpopupinfo.isHomeTypes">
      <p-button icon="pi pi-angle-left" (onClick)="_abpopupinfo.onSaveIdiaBack()" styleClass="p-button-rounded p-button-secondary p-button-text"></p-button>
    </div>
    <span *ngIf="!_abpopupinfo.isHomeTypes" class="text-xl d-flex font-bold">
      <div class="info-prdut">
        <!-- <img src="assets/images/info-popup/saveidea-info-iocon.png" alt="save-idea"> 
          In which spaces would you use this?
         -->
      </div>
     </span>
    <div class="text-center"> 
      <span *ngIf="_abpopupinfo.isHomeTypes">How many bedroom house you have?</span>
    </div>
  </ng-template>
  <!-- <p class="sub-hed">Select multiple options</p> -->

  <ng-template pTemplate="content">
      <div class="info-row" *ngIf="!_abpopupinfo.isHomeTypes">
        <!-- <div class="info-card-col">
          <div class="info-card info-card-pro">
            <div class="info-img">
              <img src="assets/images/info-popup/saveidea-info-iocon.png" alt="save-idea">
            </div>
            <div class="info-content">
              <h3>Save Idea </h3>
              <p>Save your product collection <br>
                room wise
                </p>
            </div>
          </div>
        </div> -->
        <div class="info-gif-col">
          <div class="ioc-gif-box">
            <img src="https://res.cloudinary.com/afterbricks/image/upload/v1745254855/Save_Idea_2_nev4dw.png" alt="sav idea infi gif">
            <!-- <img src="assets/images/info-popup/save-idea-popup.gif" alt="sav idea infi gif"> -->
          </div>
        </div>
      </div>
      <div class="continue-strip" *ngIf="!_abpopupinfo.isHomeTypes">
        <button class="btn continue-btn" (click)="_abpopupinfo.onNext()" *ngIf="!_project.selectedProject?.id || !_as.isUserLoggedIn">Next</button>
        <button class="btn continue-btn" (click)="_abpopupinfo.onHouseTypeSave()" *ngIf="_project.selectedProject?.id && _as.isUserLoggedIn">Done</button>
      </div>
      <div *ngIf="_abpopupinfo.isHomeTypes">
          <ul class="info-ul-2 ab-project-ul">
            <li *ngFor="let val of _abpopupinfo.hometypes;let i=index">
              <div class="hometype-card" (click)="_abpopupinfo.setHomeType(val)"
                [ngClass]="{'active-hometype-card':val.id === _abpopupinfo.selectedHomeId}">
                <!-- <img [src]="val.icon" [alt]="val.name"> -->
                <span>{{val.name}}</span>
              </div>
            </li>
          </ul>
        <span *ngIf="_abpopupinfo.is_project_error" class="err-text" >Select your bedroom</span>
      </div>
      <div class="continue-strip" *ngIf="_abpopupinfo.isHomeTypes">
        <button class="btn continue-btn" (click)="_abpopupinfo.onHouseTypeSave()">Done</button>
      </div>
    </ng-template>
  </p-dialog>
  </div>
  <div class="info-popup mob" *ngIf="_as.isOnMobilePlatform">
    <p-sidebar [(visible)]="_abpopupinfo.visibleInfoPopup" position="bottom"  [showCloseIcon]="false" (onHide)="_abpopupinfo.reSetData()">
      <ng-template pTemplate="header">
        <!-- <div class="info-back-btn" *ngIf="_abpopupinfo.step_type!='user_type'" (click)="_abpopupinfo.onBack()">
          <i class="fa-solid fa-chevron-left" ></i>
        </div> -->
        <div class="info-back-btn" *ngIf="_abpopupinfo.step_type!=='user_type'">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 12 16" fill="none" aria-hidden="true">
            <path d="M6.65723 6.24707C6.76704 5.91764 7.233 5.91765 7.34281 6.24707L7.98828 8.1835C8.276 9.04666 8.95332 9.72399 9.81648 10.0117L11.7529 10.6572C12.0824 10.767 12.0824 11.233 11.7529 11.3428L9.81649 11.9883C8.95332 12.276 8.27599 12.9533 7.98828 13.8165L7.34281 15.7529C7.233 16.0823 6.76704 16.0823 6.65723 15.7529L6.01173 13.8165C5.72401 12.9533 5.04669 12.276 4.18353 11.9883L2.24707 11.3428C1.91764 11.233 1.91764 10.767 2.24707 10.6572L4.18353 10.0117C5.04669 9.72399 5.72401 9.04667 6.01173 8.18352L6.65723 6.24707Z" fill="#9763f6"></path>
            <path d="M2.79434 1.14824C2.86023 0.950586 3.1398 0.950587 3.20569 1.14824L3.59297 2.3101C3.7656 2.828 4.172 3.2344 4.6899 3.40703L5.85177 3.79432C6.04942 3.86021 6.04942 4.13978 5.85177 4.20567L4.6899 4.59296C4.172 4.76559 3.7656 5.17199 3.59297 5.68989L3.20569 6.85176C3.13981 7.04941 2.86023 7.04942 2.79434 6.85176L2.40704 5.68988C2.23441 5.17198 1.82801 4.76559 1.31012 4.59296L0.148241 4.20567C-0.0494137 4.13978 -0.0494138 3.86021 0.148241 3.79432L1.31012 3.40703C1.82802 3.2344 2.23441 2.82801 2.40704 2.31011L2.79434 1.14824Z" fill="#9763f6"></path>
            <path d="M9.8629 0.0988265C9.90682 -0.032943 10.0932 -0.0329419 10.1371 0.098828L10.3953 0.873401C10.5104 1.21867 10.7813 1.4896 11.1266 1.60469L11.9012 1.86288C12.0329 1.9068 12.0329 2.09319 11.9012 2.13711L11.1266 2.39531C10.7813 2.51039 10.5104 2.78133 10.3953 3.12659L10.1371 3.90117C10.0932 4.03294 9.90682 4.03294 9.8629 3.90117L9.6047 3.12659C9.48961 2.78132 9.21868 2.5104 8.87342 2.39531L8.09883 2.13711C7.96706 2.09319 7.96706 1.9068 8.09883 1.86288L8.87342 1.60469C9.21868 1.4896 9.48961 1.21867 9.6047 0.873408L9.8629 0.0988265Z" fill="#9763f6"></path>
          </svg>
        </div>
       
        <div class="w-100 text-center">
          <span class="text-xl font-bold"> {{_abpopupinfo.heading}} </span>
          
        <p *ngIf="_abpopupinfo.step_type==='pro-message'">Get qualified leads, e-business tags, and much more</p>
        </div>
        
      </ng-template>
      <ng-template pTemplate="content">
        <div *ngIf="_abpopupinfo.step_type==='user_type'">
          <ul class="info-ul-1">
            <li *ngFor="let ut of _abpopupinfo.usertypedata">
              <a class="info-card" [ngStyle]="{'background-color':ut.bgColor}" (click)="_abpopupinfo.onSelectUserType(ut.key)">
                <div class="info-img">
                  <img [src]="ut.icon" [alt]="ut.title">
                </div>
                <div class="info-content">
                  <h3>{{ut.title}}</h3>
                  <!-- <h3 [ngStyle]="{'color':ut.color}">{{ut.title}}</h3> -->
                  <!-- <p>{{ut.subtitle}}</p> -->
                  <!-- <p [ngStyle]="{'color':ut.color}">{{ut.subtitle}}</p> -->
                </div>
              </a>
            </li>
          </ul>
         
          <div class="footer-msg" >
            <span>{{_abpopupinfo.footermsg}}</span><br>
            <span  style="font-size: 11px; font-family:'SF UI Text Regular';">{{_abpopupinfo.footermsgtwo}}</span>
          </div>
        </div>
        <div class="position-relative" *ngIf="_abpopupinfo.step_type==='product-selection-for'">
          <ul class="info-ul-1">
            <li *ngFor="let ut of _abpopupinfo.productSelectionfor">
              <a class="info-card " [ngStyle]="{'background-color':ut.bgColor}" (click)="_abpopupinfo.onProductSelectionFor(ut.key)">
                <div class="info-img">
                  <img [src]="ut.icon" [alt]="ut.title">
                </div>
                <div class="info-content">
                  <h3>{{ut.title}}</h3>
                  <p>{{ut.subtitle}}</p>
                </div>
              </a>
            </li>
          </ul>
          <div class="text-center mt-3 mb-3" *ngIf="!_abpopupinfo.isAskBudgetSec">
            <span>Please click as per your project requirements</span>
          </div>
          <div class="full-renovartion-strip" *ngIf="_abpopupinfo.isAskBudgetSec">
            <div class="footer-msg " >
              <h3>Would you like to explore our budget optimization tool?</h3>
              <p>It allocates the entire budget to individual product categories</p>
              <div class="fns-btn-box">
                <button (click)="_abpopupinfo.onGoBudgetSec()">Yes</button>
                <button (click)="_abpopupinfo.onProduct();">Latter</button>
              </div>
            </div>
          </div>
          
        </div>
        <div *ngIf="_abpopupinfo.step_type==='pro-message'">
          <ul class="info-ul-2">
            <li *ngFor="let ut of _abpopupinfo.profeaturelist">
              <a class="info-card info-card-pro">
                <div class="info-img">
                  <img [src]="ut.icon" [alt]="ut.title">
                </div>
                <div class="info-content">
                  <h3>{{ut.title}}</h3>
                  <p style="font-size: 12px !important;">{{ut.subtitle}}</p>
                </div>
              </a>
            </li>
          </ul>
          <div class="continue-strip d-flex">
            <button class="later-btn"  (click)="_abpopupinfo.onContinue()">Later</button>
            <!-- <p-button label="Later" (onClick)="_abpopupinfo.onSkip()" styleClass="p-button-secondary p-button-text mr-2"></p-button> -->
            <button class="btn continue-btn" (click)="goSmartsearch()">Try now</button>
          </div>
        </div>
  </ng-template>
  </p-sidebar>
  <p-sidebar [(visible)]="_abpopupinfo.is_displaySaveIdeaInfoPopup" position="bottom"  [showCloseIcon]="false">
    <ng-template pTemplate="header">
      <div class="info-back-btn" (click)="_abpopupinfo.onSaveIdiaBack()" *ngIf="_abpopupinfo.isHomeTypes">
        <i class="fa-solid fa-chevron-left" ></i>
        
      </div>
      <!-- <span *ngIf="!_abpopupinfo.isHomeTypes" class="text-xl d-flex font-bold">
        <div class="info-prdut">
          <img src="assets/images/info-popup/saveidea-info-iocon.png" alt="save-idea">
        </div>
        Save products for every room</span> -->
      <div class="text-center"> 
        <span *ngIf="_abpopupinfo.isHomeTypes">How many bedrooms?</span>
      </div>
    
    </ng-template>
    <ng-template pTemplate="content">
        <div class="info-row" *ngIf="!_abpopupinfo.isHomeTypes">
          <!-- <div class="info-card-col">
            <div class="info-card info-card-save-idea">
              <div class="info-img">
                <img src="assets/images/info-popup/saveidea-info-iocon.png" alt="save-idea">
              </div>
              <div class="info-content info-content-save-idea">
                <h3>Save Idea </h3>
                <p>Save your product collection <br>
                  room wise
                  </p>
              </div>
            </div>
          </div> -->
          <div class="info-gif-col">
            <div class="ioc-gif-box">
              <img src="https://res.cloudinary.com/afterbricks/image/upload/v1745254855/Save_Idea_2_nev4dw.png" alt="save idea info gif">
            </div>
          </div>
        </div>
        <div class="continue-strip" *ngIf="!_abpopupinfo.isHomeTypes">
          <button class="btn continue-btn" (click)="_abpopupinfo.onNext()">Next</button>
        </div>
        <div *ngIf="_abpopupinfo.isHomeTypes">
          <!-- <div class="ab-project-box"> -->
            <ul class="info-ul-2 ab-project-ul">
              <li *ngFor="let val of _abpopupinfo.hometypes;let i=index">
                <div class="hometype-card" (click)="_abpopupinfo.setHomeType(val)"
                  [ngClass]="{'active-hometype-card':val.id === _abpopupinfo.selectedHomeId}">
                  <!-- <img [src]="val.icon" [alt]="val.name"> -->
                  <span>{{val.name}}</span>
                </div>
              </li>
            </ul>
          <!-- </div> -->
          <span *ngIf="_abpopupinfo.is_project_error" class="err-text" style="position: absolute;">Select one option from the list</span>
        </div>
        <div class="continue-strip" *ngIf="_abpopupinfo.isHomeTypes">
          <button class="btn continue-btn" (click)="_abpopupinfo.onHouseTypeSave()">Done</button>
        </div>
      </ng-template>
    </p-sidebar>
  </div>
  